var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02632 4.88C5.42193 4.88 2.5 7.80194 2.5 11.4063C2.5 15.0191 3.94498 16.8274 9.99323 21.5316L12.7721 23.6929C13.4943 24.2547 14.5057 24.2547 15.2279 23.6929L18.0068 21.5316C24.055 16.8274 25.5 15.0191 25.5 11.4063C25.5 7.80194 22.5781 4.88 18.9737 4.88C17.1022 4.88 15.4359 5.73037 14 7.36655C12.5641 5.73037 10.8978 4.88 9.02632 4.88Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.7066b7ef463f6fea1cedff02a3ebcf37.svg";
export { ForwardRef as ReactComponent };